import { SplashProps } from 'components/shared/surfaces/Splash/Splash.types';
import { muiStyles } from 'utils/design';

export const useStyles = muiStyles<SplashProps>((_theme, { height }) => ({
  splash: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height,
    width: '100%',
  },
}));
